/* global gettext */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormError from 'components/form/FormError';
import { MARKETING_CAMPAIGNS } from '../../consts/marketingCampaigns';

const CAMPAIGN_LABELS = {
  [MARKETING_CAMPAIGNS.WEEKLY_NEWSLETTER_ICS]: 'Weekly Newsletter - ICs',
  [MARKETING_CAMPAIGNS.WEEKLY_NEWSLETTER_MANAGERS]: 'Weekly Newsletter - Managers',
  [MARKETING_CAMPAIGNS.LEARNER_CHALLENGES_QUARTERLY]: 'Learner Challenges (Quarterly)',
  [MARKETING_CAMPAIGNS.NEWS_AND_UPDATES_QUARTERLY]: 'News and Updates (Quarterly)'
};

const MarketingCampaignsFieldset = ({ requestState, disabled }) => {
  return (
    <fieldset>
      <legend>{gettext('Marketing Campaigns')}</legend>

      {Object.entries(MARKETING_CAMPAIGNS).map(([key, id]) => (
        <React.Fragment key={id}>
          <label htmlFor={id}>
            <Field
              id={id}
              name={id}
              component="input"
              type="checkbox"
              props={{ disabled }}
            />
            {gettext(CAMPAIGN_LABELS[id])}
          </label>
          <FormError name={id} requestState={requestState} />
        </React.Fragment>
      ))}
    </fieldset>
  )
};

MarketingCampaignsFieldset.propTypes = {
  requestState: ImmutablePropTypes.map.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default MarketingCampaignsFieldset;